module.exports = __webpack_public_path__ + "static/media/favs9.ed21f9dc.jpg";